import request from '@/utils/request'

let Supplier_settledApi = {

  /*供应商入驻列表*/
  list(data) {
    return request._post('/shop/plus.supplier_settled.Index/index', data);
},
/*添加供应商入驻*/
add(data) {
    return request._post('/shop/plus.supplier_settled.Index/add', data);
},
/*修改供应商入驻*/
edit(data) {
    return request._post('/shop/plus.supplier_settled.Index/edit', data);
},
/*删除供应商入驻*/
del(data) {
    return request._post('/shop/plus.supplier_settled.Index/del', data);
},
/*供应商入驻详情*/
detail(data) {
  return request._post('/shop/plus.supplier_settled.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.supplier_settled.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.supplier_settled.Setting/getSetting', data, errorback);
    },
     // 审核
 passCanel(data) {
    return request._post('/shop/plus.supplier_settled.Index/passCanel', data);
  },
}
export default Supplier_settledApi;



// WEBPACK FOOTER //
// ./src/api/supplier_settled.js